// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_NEXT_INSERTIONS, ARCHIVE_V3_SUMMARY } from 'src/app/shared/utils/archive-v3-redirect.utils';

// Custom packages - Component
import { NextInsertionsDocsListComponent } from 'src/app/modules/summary-docs/pages/next-insertions/next-insertions-list.page';
import { SummaryDocsListComponent } from 'src/app/modules/summary-docs/pages/summary-docs-list/summary-docs-list.page';

// Both pages open their summary-docs-v3 successor once the 3.0.0 archive is live (FE-A1,
// ArchiveV3RedirectGuard); until the switch they open as before
const routes: Routes = [
  {
    path: 'list',
    component: SummaryDocsListComponent,
    canActivate: [ArchiveV3RedirectGuard, RoleGuard],
    data: {
      permissions: ['canReadDocumentsList'],
      archiveV3Redirect: ARCHIVE_V3_SUMMARY,
    },
  },
  {
    path: 'insertions-list',
    component: NextInsertionsDocsListComponent,
    canActivate: [ArchiveV3RedirectGuard, RoleGuard],
    data: {
      permissions: ['canReadDocumentsList'],
      archiveV3Redirect: ARCHIVE_V3_NEXT_INSERTIONS,
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class SummaryDocsRoutingModule { }
